// extracted by mini-css-extract-plugin
export default {"root":"Paginate_root__Nprfn","previous":"Paginate_previous__6CsJP","next":"Paginate_next__zzER+","button":"Paginate_button__+59lO","selected":"Paginate_selected__g8aBw"};